import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(private http: HttpClient) {}

  handleFile(files: File, extensions: string[]): File | null {
    if(!files) return null;  
    let fileType = files && files.type ? files.type : '';
    if (!extensions.includes(fileType)) {
      return null;
    }
    return files;
  }

  handleFileMultiple(files: File[], extensions: string[]): File[] | null {
    const validValid = [];
    if (files.length === 0) {
      return null;
    }

    for (var i = 0; i < files.length; i++) {
      let fileType =
        files && files[i].type ? files[i].type : '';
      if (extensions.includes(fileType)) {
        validValid.push(files[i]);
      }
    }
    return validValid;
  }

  async uploadFile(url: string, file: File): Promise<any> {
    const params = { token: 'false' };
    return await firstValueFrom(
      this.http.put(url, file, { headers: { 'Content-Type': '' }, params })
    );
  }
}
